/**
 * @file: useTextInputRow.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCallback, useRef } from 'react';
import { TextInput } from 'react-native';
import { useOrderFormStyles } from '../form/components/styles';

export const useTextInputRow = () => {
  const inputRef = useRef<TextInput>(null);
  const styles = useOrderFormStyles();

  const onCellPress = useCallback(() => {
    inputRef.current?.focus();
  }, []);

  return { inputRef, onCellPress, inputStyle: styles.formInput };
};
